import React, { Fragment, useState } from 'react';
import { Dialog, Transition, Combobox } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faPaw, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import api from '../../../api/api';

const DriverAssign = ({ delivery, isOpen, onClose, drivers }) => {
    const [selectedDriver, setSelectedDriver] = useState(delivery.driver || null);
    const [query, setQuery] = useState('');

    const filteredDrivers = query === ''
        ? drivers
        : drivers.filter((driver) =>
            driver.email.toLowerCase().includes(query.toLowerCase())
        );

    const handleAssignDriver = async () => {
        if (!selectedDriver) return;

        try {
            await api.put(`/deliveries/${delivery.id}`, {
                driver_id: selectedDriver.id,
                settingUpDriver: true
            });
            onClose(); // close modal after successful assignment
        } catch (error) {
            // Error assigning Driver
        }
    };

    if (!delivery) return null;

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-full p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-8 text-left align-middle shadow-xl transition-all">
                                {/* Header */}
                                <div className="flex justify-between items-start mb-4">
                                    <Dialog.Title as="h3" className="text-2xl font-semibold leading-6 text-gray-900">
                                        Assign Driver
                                    </Dialog.Title>
                                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-transform transform hover:scale-105">
                                        <FontAwesomeIcon icon={faTimesCircle} className="w-5 h-5" />
                                    </button>
                                </div>

                                {/* Driver Selection ComboBox */}
                                <Combobox value={selectedDriver} onChange={setSelectedDriver}>
                                    {/* <Combobox.Label className="block text-sm font-medium text-gray-700">Select Driver</Combobox.Label> */}
                                    <div className="relative mt-2">
                                        <Combobox.Input
                                            className="w-full border border-gray-300 rounded-lg shadow-sm py-2 px-3 text-sm leading-5 text-gray-900"
                                            displayValue={(driver) => driver?.email || ''}
                                            onChange={(event) => setQuery(event.target.value)}
                                            placeholder="Search for a driver..."
                                        />
                                        <Combobox.Options className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto focus:outline-none sm:text-sm">
                                            {filteredDrivers.length === 0 && query !== '' ? (
                                                <div className="cursor-default select-none py-2 px-4 text-gray-700">
                                                    No drivers found.
                                                </div>
                                            ) : (
                                                filteredDrivers.map((driver) => (
                                                    <Combobox.Option
                                                        key={driver.id}
                                                        className={({ active }) =>
                                                            `relative cursor-pointer select-none py-2 pl-10 pr-4 ${active ? 'text-white bg-purple-600' : 'text-gray-900'}`
                                                        }
                                                        value={driver}
                                                    >
                                                        {({ selected, active }) => (
                                                            <>
                                                                <span
                                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                        }`}
                                                                >
                                                                    {driver.email}
                                                                </span>
                                                                {selected && (
                                                                    <span
                                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-purple-600'}`}
                                                                    >
                                                                        <FontAwesomeIcon icon={faPaw} />
                                                                    </span>
                                                                )}
                                                            </>
                                                        )}
                                                    </Combobox.Option>
                                                ))
                                            )}
                                        </Combobox.Options>
                                    </div>
                                </Combobox>

                                {/* Assign Button */}
                                <motion.div
                                    className="mt-6 flex justify-center"
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ type: 'spring', stiffness: 300 }}
                                >
                                    <button
                                        onClick={handleAssignDriver}
                                        className="px-4 py-2 bg-purple-600 text-white rounded-lg shadow-md hover:bg-purple-700 flex items-center space-x-2"
                                        disabled={!selectedDriver}
                                    >
                                        <FontAwesomeIcon icon={faUserCheck} className="w-4 h-4" />
                                        <span>Assign this Driver</span>
                                    </button>
                                </motion.div>


                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default DriverAssign;
